import { LIGHTMETRICS_MANUFACTURER, FALLBACK_TIME_ZONE } from './constants';
import { isValidTimeZone, parseInstant } from './timeZone';

export const isLightMetricsItem = (item) =>
  String(item?.linkedDevice?.manufacturerName || '').trim().toLowerCase() === LIGHTMETRICS_MANUFACTURER &&
  Boolean(item?.linkedDevice?.id);

export const toVideoUnit = (item) => {
  const zoneName = item.unit?.timeZone?.name;
  let timeZone = FALLBACK_TIME_ZONE;
  if (isValidTimeZone(zoneName)) timeZone = zoneName;
  return {
    cameraDeviceId: item.linkedDevice.id,
    // Trips, dates and trails belong to the unit (what the map shows); the camera id is only for the request.
    activityUnitId: String(item.unit?.id ?? item.linkedDevice.id),
    label: item.unit?.label || item.unit?.esn || item.linkedDevice.id,
    esn: item.unit?.esn || '',
    modelName: item.linkedDevice.deviceModelName || '',
    timeZone,
    usesFallbackZone: timeZone === FALLBACK_TIME_ZONE && zoneName !== FALLBACK_TIME_ZONE,
  };
};

export const toTrip = (item) => {
  const startMs = parseInstant(item.start?.unitTime);
  const endMs = parseInstant(item.end?.unitTime);
  return {
    id: `${startMs}-${endMs}`,
    startMs,
    endMs,
    durationMs: endMs - startMs,
    driverName: item.start?.driverName || '',
  };
};

export const normalizeTrips = (items) =>
  (items || [])
    .filter(Boolean)
    .map(toTrip)
    .filter((trip) => Number.isFinite(trip.startMs) && Number.isFinite(trip.endMs) && trip.endMs > trip.startMs)
    .sort((a, b) => a.startMs - b.startMs);
